'use client';

import { motion } from 'motion/react';
import React from 'react';

import RichText from '@/components/RichText';
import type { ThreeColumnsBlock as ThreeColumnBlocksProps } from '@/payload-types';
import { cn } from '@/utils/cn';

import { BlockSettings } from '../BlockSettings';
import styles from './block.module.scss';

const itemVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 50 },
};

export const ThreeColumnsBlock: React.FC<ThreeColumnBlocksProps> = (props) => {
  const {
    backgroundColor,
    columns,
    individualSpacing,
    label,
    spacing,
    spacingBottom,
    spacingTop,
    tag,
  } = props;

  if (!columns || !Array.isArray(columns) || columns.length === 0) {
    return null;
  }

  const LabelTagElement = tag || 'h2';

  return (
    <BlockSettings
      backgroundColor={backgroundColor}
      individualSpacing={individualSpacing}
      spacing={spacing}
      spacingBottom={spacingBottom}
      spacingTop={spacingTop}
    >
      <div className={'container'}>
        {label && (
          <LabelTagElement className={styles.label}>{label}</LabelTagElement>
        )}
        <motion.div
          initial='hidden'
          whileInView='visible'
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.3,
              },
            },
          }}
          className={cn(styles.list)}
        >
          {columns.map((item, index) => {
            const { content, heading, headingAppearance } = item;

            if (!content && !heading) {
              return null;
            }

            return (
              <motion.div
                key={index}
                variants={itemVariants}
                style={{ willChange: 'opacity, transform' }}
                transition={{ duration: 0.3 }}
                className={styles.item}
              >
                <h3 className={cn(styles.heading, headingAppearance)}>
                  {heading}
                </h3>
                <RichText content={content || {}} enableGutter={false} />
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </BlockSettings>
  );
};
